<template>
  <div class="action-bar__mobile-row">
    <AlertBox
      v-if="maintenanceMode"
      class="mt-4 maintenance-mode"
      icon="attention"
      :style="'danger'"
    >
      <template #default>
        <LibRichTextRenderer :rich-text="maintenanceModeText" />
      </template>
    </AlertBox>
    <template v-else>
      <Button
        v-if="displayAddToCartButton"
        style-type="attraction"
        icon-type="icon-left"
        icon-name="add-shopping-cart"
        :icon-scale="1.4"
        size="medium"
        :active-state="isInitialLoading ? 'loading' : addToCartButtonState"
        :disabled="isInitialLoading || addToCartButtonDisabled"
        :states="{
          loading: {
            hideText: false,
            ariaText:
              $textDictionary['pdp.addToCart.buttonState.loading'] ??
              'pdp.addToCart.buttonState.loading',
            resetDelay: -1
          },
          error: {
            hideText: false,
            ariaText:
              $textDictionary['pdp.addToCart.buttonState.error'] ??
              'pdp.addToCart.buttonState.error',
            resetDelay: 2000
          },
          success: {
            hideText: false,
            ariaText:
              $textDictionary['pdp.addToCart.buttonState.success'] ??
              'pdp.addToCart.buttonState.success',
            resetDelay: 2000
          }
        }"
        @click="
          $emit(
            'add-to-cart',
            loggedIn ? CartTypes.CUSTOMER_CART : CartTypes.CART
          )
        "
      >
        {{ addToCartMobile }}
      </Button>

      <Button
        style-type="link"
        size="small"
        :expand="true"
        icon-name="arrow-up-bold"
        icon-type="icon-left"
        @click="$emit('show-options')"
      >
        {{
          $textDictionary['pdp.showOptions.label'] ?? 'pdp.showOptions.label'
        }}
      </Button>
    </template>
  </div>
</template>

<script setup lang="ts">
import { AlertBox, Button } from '@hypercodestudio/basler-components';
import type { BtnStateType } from '@hypercodestudio/basler-components/dist/components/elements/Button.vue';
import { type CartType, CartTypes } from '~/stores/cartStore/model';

const { $textDictionary, $globalPageSettings, $dictionary } = useNuxtApp();

const maintenanceModeText = $dictionary.value['maintenanceMode.text'];

const maintenanceMode = computed(() => {
  return $globalPageSettings.value?.shopConfig?.maintenanceMode;
});

interface Props {
  isInitialLoading: boolean;
  addToCartButtonState: BtnStateType;
  addToCartButtonDisabled: boolean;
  priceText: string;
  loggedIn: boolean;
  displayAddToCartButton: boolean;
}

const props = defineProps<Props>();

const addToCartMobile = computed(() => {
  return (
    $textDictionary.value['pdp.addToCartMobile.label']?.replace(
      '{price}',
      String(props.priceText)
    ) ?? 'pdp.addToCartMobile.label'
  );
});

defineEmits<{
  'add-to-cart': [type: CartType];
  'show-options': [];
}>();
</script>

<style scoped></style>
